import { Link } from "react-router-dom";
import { footerLinks } from "@/mocks/home";
import StoreBadges from "@/components/feature/StoreBadges";
import Logo from "@/components/feature/Logo";
import { track } from "@/lib/analytics";

const SOCIALS = [
  { icon: "ri-facebook-fill", label: "Facebook", href: "https://www.facebook.com/Joble-100068542480417/" },
  { icon: "ri-twitter-x-fill", label: "X", href: "https://x.com/jobleapp" },
  { icon: "ri-instagram-line", label: "Instagram", href: "https://www.instagram.com/jobleapp/" },
  { icon: "ri-linkedin-fill", label: "LinkedIn", href: "https://www.linkedin.com/company/joble-app" },
];

export default function Footer() {
  return (
    <footer className="relative w-full bg-background-50 overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-background-300/40 to-transparent"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8 items-start">
          <div className="lg:col-span-2 flex flex-col">
            <div className="flex items-center mb-6">
              <Logo imgClassName="h-8" />
            </div>
            <p className="text-base font-medium text-foreground-900 leading-normal mb-1">
              Powering connections.
            </p>
            <p className="text-sm text-foreground-600 leading-normal mb-8">Sell more. Spend less.</p>
            <div className="flex items-center gap-3">
              {SOCIALS.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 rounded-full bg-background-100/60 border border-background-300/40 flex items-center justify-center text-foreground-700 hover:text-foreground-950 hover:border-primary-500/40 transition-all duration-200 cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`} aria-hidden></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-[0.15em] mb-6">
              Resources
            </h4>
            <ul className="space-y-4">
              {footerLinks.resources.map((link) => (
                <li key={link.label}>
                  {link.href.startsWith("/") ? (
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-[0.15em] mb-6">
              Company
            </h4>
            <ul className="space-y-4">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  {link.href.startsWith("/") ? (
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col">
            <h4 className="text-sm font-semibold text-foreground-900 tracking-wide mb-5">
              Contact us
            </h4>
            <a
              href="mailto:support@joble.app"
              className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors mb-6 break-all cursor-pointer"
            >
              support@joble.app
            </a>
            <a
              href="https://app.joble.app/auth/create-account?free=true"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("try_joble_clicked", { location: "footer" })}
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 text-foreground-950 text-sm font-semibold px-5 py-2.5 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap self-start"
            >
              Try Joble Now
            </a>
            <div className="mt-7">
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-[0.15em] mb-3">
                Get the app
              </h4>
              <StoreBadges justify="start" direction="col" fullWidth />
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-300/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} Joble. All rights reserved.
          </p>
          <p className="text-xs text-foreground-600">Powering connections, one conversation at a time.</p>
        </div>
      </div>
    </footer>
  );
}